import React, { forwardRef } from 'react'
import { Box, IconButton, Icon, Typography, useMediaQuery } from '@mui/material'
import { useNavigate, useLocation } from 'react-router-dom'
import AdxButton from 'components/custom/AdxButton'

const AllRequestHeader = forwardRef((props, ref) => {
  let navigate = useNavigate()
  let location = useLocation()
  const isSmall = useMediaQuery((theme) => theme.breakpoints.up('sm'))

  const navigateBack = () => {
    navigate('../overview')
  }

  const handleCreateNew = () => {
    navigate('/app/leave/request/create', {
      state: {
        backgroundLocation: location,
      },
    })
  }

  return (
    <Box
      ref={ref}
      sx={{
        display: 'flex',
        justifyContent: 'end',
        alignItems: 'center',
      }}
    >
      <AdxButton onClick={handleCreateNew} sx={{ gap: 1, width: { xs: 1, md: 'fit-content' } }}>
        <Icon>add</Icon>
        Request Leave
      </AdxButton>
    </Box>
  )
})

export default AllRequestHeader
